import 'views/registration/pack.less'

import {Icon} from '@codeurs/front'
import {PackModel} from 'models/configuration/PackModel'
import {RegistrationModel} from 'models/registration/RegistrationModel'
import {SelectStepModel} from 'models/registration/steps/SelectStepModel'
import React from 'react'
import {formatPrice} from 'util/currency'
import {style} from 'util/style'
import {Theme} from 'views/theme'

const styles = style('pack', ['price'])

export const Pack: React.FC<{
	step: SelectStepModel
	pack: PackModel
	updateRegistration: (model: RegistrationModel) => void
}> = ({step, pack, updateRegistration}) => {
	return (
		<button
			key={pack.key}
			{...styles
				.mod({
					selectable: true,
					large: pack.isLarge,
					unavailable: pack.disabled
				})
				.is({selected: step.registration.packsSet.has(pack)})}
			onClick={() => {
				if (!pack.disabled) updateRegistration(step.togglePack(pack))
			}}
		>
			<div {...styles('details')}>
				<div {...styles('heading')}>
					<h2 {...styles('heading-title')}>{pack.label}</h2>
					<Theme.Wysiwyg {...styles('heading-description')}>
						{pack.description}
					</Theme.Wysiwyg>
				</div>
				<div {...styles('price')}>
					{pack.originalPrice !== false && (
						<div {...styles('price-original')}>
							{formatPrice(pack.originalPrice)}
						</div>
					)}
					<div {...styles('price-amount')}>
						{formatPrice(pack.getPriceFor(step.registration))}
					</div>
					<div {...styles('price-disclaimer')}>excl. VAT</div>
				</div>
				<div {...styles('toggle')}>
					<div {...styles('toggle-arrow')}>
						<Icon
							icon={
								step.registration.packsSet.has(pack)
									? 'register-checkmark'
									: 'register-plus'
							}
						/>
					</div>
				</div>
			</div>
			<div {...styles('footer')} />
		</button>
	)
}
